// extracted by mini-css-extract-plugin
export default {"faqs":"faqs_faqs__G2XUO","faq":"faqs_faq__ISe+Y","head":"faqs_head__KmQoa","title":"faqs_title__WqbKQ","content":"faqs_content__nXNuu"};